import React from "react";
import "./About.css";
import founderImage from "../assets/founder/mmola.png"; // replace with your actual path

export default function About() {
  return (
    <div className="container">
      <section id="about" className="about-section">
        <h2>Mapesa Foundation</h2>

        <div className="about-wrapper fade-in show">
          <div className="about-image">
            <img
              src={founderImage}
              alt="Founder"
              width="280"
              height="280"
              style={{ borderRadius: "15px", objectFit: "cover" }}
            />
          </div>

          <div className="about-info fade-in show">
            <p>
              Founded in 2021 by <strong>Mr. Khomotso Mola</strong>, the Mapesa Foundation is dedicated to empowering disadvantaged youth through education, mentorship, and impactful community programs.
            </p>
            <p>
              Our mission is to provide support, opportunities, and guidance that enable young people to unlock their full potential and build brighter, sustainable futures.
            </p>
          </div>
        </div>

        <div className="mv-section fade-in show">
          <div className="mv-card fade-in show">
            <h3>Mission Statement</h3>
            <p>
              Mapesa Foundation aims to provide the currently disadvantaged girl and boy child opportunities that centre around holistic development and wellbeing. This is achieved through funding, mentorship, and engagement in diverse social activities.
            </p>
          </div>

          <div className="mv-card fade-in show">
            <h3>Vision Statement</h3>
            <p>
              Our organisation envisions a future where the girl and boy child under our foundation thrives in a supportive and empowering environment, unlocking their full potential through comprehensive development and wellbeing. We aspire to create a world where access to resources, mentorship, and enriching social experiences are the norm, fostering generations of confident, capable, and compassionate individuals.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
